import { getCurrentInstance } from 'vue';

export const useTranslation = () => {
    const { proxy } = getCurrentInstance();
    const { $Trans } = proxy;

    return $Trans;
};
